// extracted by mini-css-extract-plugin
export default {"modal_parent":"AccessAccount_modal_parent__Mkr8S","parent":"AccessAccount_parent__lGibm","close_btn":"AccessAccount_close_btn__lXHJ-"};